goog.provide("shadow.js.shim.module$src$svg$wpp$content$map_svg$default");
shadow.js.shim.module$src$svg$wpp$content$map_svg$default = shadow.js.shim.module$src$svg$wpp$content$map_svg.default;
